import api from "./api"

export const normalizeAdminCompanyForBilling = (company) => {
  const now = new Date()
  const trial = company?.freeTrial || {}
  const portalOverride = company?.portalCommissionOverride || {}
  const startsAt = trial.startsAt ? new Date(trial.startsAt) : null
  const endsAt = trial.endsAt ? new Date(trial.endsAt) : null
  const startsOk = !startsAt || now >= startsAt
  const endsOk = !endsAt || now <= endsAt

  return {
    ...company,
    propertyCount: Number(company?.propertyCount || 0),
    freeTrial: {
      enabled: Boolean(trial.enabled),
      startsAt: trial.startsAt || null,
      endsAt: trial.endsAt || null,
      reason: trial.reason || "",
      updatedBy: trial.updatedBy || null,
      updatedAt: trial.updatedAt || null,
      active: Boolean(trial.enabled && startsOk && endsOk),
    },
    portalCommissionOverride: {
      enabled: Boolean(portalOverride.enabled),
      percentage: portalOverride.percentage ?? null,
      reason: portalOverride.reason || "",
      updatedBy: portalOverride.updatedBy || null,
      updatedAt: portalOverride.updatedAt || null,
    },
  }
}

export const normalizeAdminCompaniesResponse = (response) => {
  const items = Array.isArray(response?.data?.managementCompanies) ? response.data.managementCompanies : []
  return items.map(normalizeAdminCompanyForBilling)
}

export const fetchAdminCompanies = async () => {
  const response = await api.get("/management-company/admin/free-trials")
  return normalizeAdminCompaniesResponse(response)
}
